<template>
  <div>
     <y-dialog sureText="导出" @comfirm="sureExport" @close="goBack" title="身份验证" :before-close="goBack" :visible.sync="sendDialog" width="438px" style="min-width: 1200px;">
      <div class="export-dialog-wrapper">
        <y-tip type="yellow">
          为了保护您的数据安全，导出数据需要手机验证
        </y-tip>
        <div class="hug-send">
          <div class="send-left" style="line-height: 28px;">手机号：</div>
          <div class="send-right">
            <span>
              <span>{{ $maskPhoneNumber(phone) }}</span>
              <!-- <span
                style="margin-left: 30px;line-height: 28px; cursor: pointer;"
                :style="{'color': globalBG}"
                @click="toChangePhone"
              >修改</span> -->
            </span>
          </div>
        </div>
        <div class="hug-send">
          <div class="send-left" style="line-height: 28px;">验证码：</div>
          <div class="send-right send-right2" >
            <input type="tel" class="codeBtn" v-model="code" placeholder="请输入验证码" style />
            <y-button type="default" @click="getCode" :disabled="codeDisabled">{{ codeMsg }}</y-button>
            
          </div>
        </div>
        <!-- <div class="hug-send" style="margin-top: 5px;" v-if="successMsg">
          <div class="msg" style="height: 15px;">{{successMsg}}</div>
        </div> -->
      </div>
      
    </y-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import{ sendSmsVerifyCode } from "@/api/public"
export default {
  name: '',
  props: {
    phone: {
      type: String,
      default: ''  
    },
    sendDialog: {
      type: Boolean,
      default: true
    },
    sendType: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      code: '',
      successMsg: '',
      countdown: 60, // 倒计时s
      codeMsg: '获取验证码', // 按钮上的文字
      codeDisabled: false, // 按钮可点击，是否绑定手机
      timer: null, //验证码定时
    }
  },
   computed: {
    ...mapState({
      globalBG: "globalBG"
      //   把city映射给currentCIty
    })
  },
  methods: {
    // 后退回调
    goBack() {
      this.$emit('goBack')
    },
    // 验证码60秒倒计时
    getCode() {
      if (!this.timer) {
        let obj = {
          mobile: this.phone,
          sendType: this.sendType
        };
        
        sendSmsVerifyCode(obj).then(res => {
          if (res.code == 200) {
            this.successMsg = res.message;
          }
        });
        this.timer = setInterval(() => {
          if (this.countdown > 0 && this.countdown <= 60) {
            this.countdown--;
            if (this.countdown !== 0) {
              this.codeMsg = "重新发送(" + this.countdown + ")";
            } else {
              clearInterval(this.timer);
              this.codeMsg = "获取验证码";
              this.countdown = 60;
              this.timer = null;
              this.codeDisabled = false;
            }
          }
        }, 1000);
      }
    },

    // 导出按钮
    sureExport() {
       //验证后导出数据
      if (this.code == "") {
        this.$message.warning("请输入验证码");
        return;
      }
      var obj = {
        vcode: this.code
      }
      this.$emit('sureExport', obj)
    },

    toChangePhone() {
       //跳转到帐号设置绑定手机
      let routeUrl = this.$router.resolve({
        path: "/backstage/account",
        // query: {
        //   to: "/backstage/accountset"
        // }
      });
      window.open(routeUrl.href, "_blank");
    }
  }
}
</script>

<style scoped lang="scss">
/** 导出数据模态框 */
.sendHug {
  width: 345px;
  height: 30px;
  background: rgba(255, 185, 94, 0.1);
  padding-left: 14px;
  font-size: 12px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  line-height: 30px;
  color: rgba(255, 119, 0, 1);
  border: 1px solid #ffb95e;
  border-radius: 2px;
  i {
    font-size: 14px;
    margin-right: 2px;
  }
}
.hug-send {
  // overflow: hidden;
  display: inline-block;
  margin-top: 20px;
  // height: 35px;
  .send-left {
    float: left;
    height: 20px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 20px;
    color: #333;
  }
  .send-right {
    float: left;
    font-size: 15px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 21px;
    color: rgba(51, 51, 51, 1);
  }
  .send-right2 {
    height: 32px;
  }
  .codeBtn {
    border: none;
    width: 200px;
    display: inline-block;
    line-height: 32px;
    height: 32px;
    box-sizing: border-box;
    font-size: 12px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    outline-style: none;
    float: left;
    border: 1px solid #eee;
    padding: 8px 10px;
    margin-right: 16px;
  }
  .getNumber {
    display: inline-block;
    float: left;
    width: 100px;
    border: none;
    background: none;
    outline-style: none;
    height: 32px;
    border-radius: 2px;
    line-height: 32px;
    color: #333333;
    border: 1px solid #cccccc;
  }
  .msg {
    font-size: 10px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 14px;
    color: rgba(153, 153, 153, 1);
    text-align: center;
  }
}
/** end */
</style>>